import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { isString } from 'lodash';
import { DateTime } from 'luxon';
import type { OnyxTime } from '../components/timepicker/interfaces';

export const onyxMaxTimeValidator =
  (max: DateTime | OnyxTime = DateTime.now()): ValidatorFn =>
  (control: AbstractControl<OnyxTime>): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;

    const maxTime = isString(max) ? max : max.toFormat('HH:mm:ss');
    return value > maxTime ? { maxTime: maxTime.slice(0, 5) } : null;
  };
